import Moment from 'moment'

export default {
  data() {
    return {
      curMarkers: [],
      trendActive:1
    }
  },
  methods: {
    // 初始化区域信息
    initAreaInfo() {
      if (this.userInfo.userType == 0 || this.userInfo.userType == 2 || this.userInfo.userType == 3) {
        // 经营者、超级管理员、管家，三种账号类型默认初始化全国
        return
      }

      if (this.userInfo.provinceId) {
        this.curAreaInfoPinyin.dwbgdzSfbm = this.userInfo.provinceId
        this.curAreaInfo.province = this.userInfo.provinceId
        this.curAreaCasList = [this.userInfo.provinceId]
      } else return // 因为需要初始化cascader，所以必须严格按照顺序赋值，没有的话就结束

      if (this.userInfo.cityId) {
        this.curAreaInfoPinyin.dwbgdzSbm = this.userInfo.cityId
        this.curAreaInfo.city = this.userInfo.cityId
        this.curAreaCasList = this.curAreaCasList.concat(this.userInfo.cityId)
      } else return

      if (this.userInfo.regionId) {
        this.curAreaInfoPinyin.dwbgdzQbm = this.userInfo.regionId
        this.curAreaInfo.region = this.userInfo.regionId
        this.curAreaCasList = this.curAreaCasList.concat(this.userInfo.regionId)
      } else return

      if (this.userInfo.streetOffice) {
        this.curAreaInfoPinyin.streetOffice = this.userInfo.streetOffice
        this.curAreaInfo.streetOffice = this.userInfo.streetOffice
        this.curAreaCasList = this.curAreaCasList.concat(this.userInfo.streetOffice)
      } else return

      if (this.userInfo.neighborCmm) {
        this.curAreaInfoPinyin.neighborCmm = this.userInfo.neighborCmm
        this.curAreaInfo.neighborCmm = this.userInfo.neighborCmm
        this.curAreaCasList = this.curAreaCasList.concat(this.userInfo.neighborCmm)
      }
    },
    // 定位地图上的房源
    focusRoom(room) {
      let poi = new BMap.Point(room.bddtjd, room.bddtwd)
      this.centerMap.centerAndZoom(poi, 19)
    },
    // 切换房源统计大小
    toggleChartEnlargeStat(type) {
      if (type === 'house') {
        this.enlargeHouseStat = !this.enlargeHouseStat
        this.initRoomStatChart()
      }
      if (type === 'manager') {
        this.enlargeManagerStat = !this.enlargeManagerStat
        this.initManagerStatChart()
      }
    },
    // 设置地图默认定位
    setDefaultPosition() {
      this.$message.warning('该区域没有房源！')

      const _this = this
      // 账号有定位，使用账号定位
      if (this.userInfo.xPoint && this.userInfo.yPoint) {
        let poi = new BMap.Point(this.userInfo.xPoint, this.userInfo.yPoint)
        this.centerMap.centerAndZoom(poi, 16)
        return
      }

      let geolocation = new BMap.Geolocation()
      geolocation.getCurrentPosition(
        function(res) {
          // 获取到用户浏览器经纬度
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            let poi = new BMap.Point(res.point.lng, res.point.lat)
            _this.centerMap.centerAndZoom(poi, 16)
          } else {
            // 实在没办法后直接展示全国地图
            let myGeo = new BMap.Geocoder()
            myGeo.getPoint(
              '中国',
              (point) => {
                if (point) {
                  _this.centerMap.centerAndZoom(point, 4)
                }
              }
            )
          }
        },
        { enableHighAccuracy: true } // 指示浏览器获取高精度的位置，默认false
      )
    },
    // 将房源渲染到地图
    renderRoomToMap() {
      let pois = []
      let markers = []
      let roomList = this.buildRoomList() // 构建一波房源信息

      if (roomList.length === 0) {
        // 为零时默认定位
        this.setDefaultPosition()
        return
      }

      // 默认 icon
      let defaultIcon = new BMap.Icon(this.locationDefaultIcon, new BMap.Size(21.3, 25))
      defaultIcon.setImageSize(new BMap.Size(21.3, 25))
      let activeIcon = new BMap.Icon(this.locationActiveIcon, new BMap.Size(21.3, 25))
      activeIcon.setImageSize(new BMap.Size(21.3, 25))

      // 标签样式
      let labelStyle = {
        color: 'white',
        fontSize: '13px',
        backgroundColor: 'transparent',
        border: '0',
        lineHeight: '23px',
        transform: 'translateX(-50%)' // 居中
      }

      roomList.forEach(item => {
        if (item.bddtjd && item.bddtwd) {
          // 只有拥有经纬度的房源会被渲染到地图上
          let poi = null
          let label = null
          let marker = null

          let callback = (e) => {
            e.domEvent.stopPropagation() // 阻止事件冒泡到地图上

            this.selectedRoomList = item.roomList // 选中房源列表
            markers.forEach(mk => {
              mk.setIcon(defaultIcon)
            })
            marker.setIcon(activeIcon)

            this.centerMap.centerAndZoom(poi, this.centerMap.getZoom())
          }

          poi = new BMap.Point(item.bddtjd, item.bddtwd) // 点位信息
          marker = new BMap.Marker(poi, { icon: defaultIcon }) // 覆盖物
          label = new BMap.Label(item.roomCount, { offset: new BMap.Size(10.5, -1) })
          label.setStyle(labelStyle)

          marker.setLabel(label)
          marker.addEventListener('click', callback)
          if (item.setTopZIndex) {
            marker.setZIndex(9)
          }

          pois.push(poi)
          markers.push(marker)
        }
      })

      this.curPois = pois
      this.curMarkers = markers
      this.centerMap.setViewport(pois)
      let markerClusterer = new BMapLib.MarkerClusterer(this.centerMap, { markers: markers })

      let oriPath = window.location.origin
      markerClusterer.setStyles([
        {
          url: oriPath + '/images/BMap_images/marker-clusterer-0.png', // /saas/static/images/BMap_images
          size: new BMap.Size(54, 54),
          textColor: 'white',
          textSize: 14
        },
        {
          url: oriPath + '/images/BMap_images/marker-clusterer-1.png',
          size: new BMap.Size(57, 57),
          textColor: 'white',
          textSize: 16
        },
        {
          url: oriPath + '/images/BMap_images/marker-clusterer-2.png',
          size: new BMap.Size(67, 67),
          textColor: 'white',
          textSize: 18
        },
        {
          url: oriPath + '/images/BMap_images/marker-clusterer-3.png',
          size: new BMap.Size(79, 79),
          textColor: 'white',
          textSize: 20
        }
      ])

      this.curMarkerClusterer = markerClusterer
    },
    // 构建房源列表，将经纬度一致的房源，塞到一个点位，并保留其他经纬度一致的点位，且在地图渲染的时候，将该聚合点位放至最上层
    buildRoomList() {
      let list = JSON.parse(JSON.stringify(this.roomList))

      for (let i = 0; i < list.length; i++) {
        list[i].roomList = [list[i]] // 同经纬度房源聚合至该点位
        list[i].setTopZIndex = true // 标志为顶层点位

        for (let j = i + 1; j < list.length; j++) {
          if (list[i].bddtjd == list[j].bddtjd && list[i].bddtwd == list[j].bddtwd) {
            list[i].roomList.push(list[j])
            list.splice(j, 1)
            j--
          }
        }
        list[i].roomCount = list[i].roomList.length
      }

      // 把上边删掉的，补回来，主要是为了地图点聚集显示正确
      this.roomList.forEach(item => {
        let isExist = false
        for (let i = 0; i < list.length; i++) {
          if (item.id === list[i].id) {
            isExist = true
            break
          }
        }
        if (!isExist && item.bddtjd && item.bddtwd) {
          let temp = JSON.parse(JSON.stringify(item))
          temp.roomCount = 1
          list.push(temp)
        }
      })

      return list
    },
    // 加载区域
    loadAreaCasNode(node, resolve) {
      let areaCode = node.value

      let disableNode = false // 是否启用禁选
      let ableAreaCode = ''
      switch (node.level) {
        case 0:
          areaCode = 0 // 第一层默认 0
          if (this.userInfo.provinceId) {
            disableNode = true
            ableAreaCode = this.userInfo.provinceId
          }
          break
        case 1:
          if (this.userInfo.cityId) {
            disableNode = true
            ableAreaCode = this.userInfo.cityId
          }
          break
        case 2:
          if (this.userInfo.regionId) {
            disableNode = true
            ableAreaCode = this.userInfo.regionId
          }
          break
        case 3:
          if (this.userInfo.streetOffice) {
            disableNode = true
            ableAreaCode = this.userInfo.streetOffice
          }
          break
        case 4:
          if (this.userInfo.neighborCmm) {
            disableNode = true
            ableAreaCode = this.userInfo.neighborCmm
          }
          break
      }
      let params = { areaCode }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'

      this.fetchData({ url, method: 'get', params }).then(res => {
        res = res.data || []
        let temp = res.map(item => {
          return {
            label: item.areaName,
            value: item.areaCode,
            disabled: disableNode && item.areaCode != ableAreaCode,
            leaf: node.level === 4 // 必须指定叶子节点，不然没有办法回显数据
          }
        })
        resolve(temp)
      })
    },
    // 处理区域变更
    handleChangeArea() {
      let areaInfo = {}
      let areaInfoPinyin = {}
      this.curAreaCasList.forEach((item, index) => {
        let key = this.areaCodeKeys[index]
        areaInfo[key] = item

        key = this.areaCodeKeysPinyin[index]
        areaInfoPinyin[key] = item
      })

      this.curAreaInfo = areaInfo
      this.curAreaInfoPinyin = areaInfoPinyin

      this.selectedRoomList = []
      this.initAllStatData()
    },
    // 构建日期成星期，或缩短日期长度
    buildListDate(listObj, type) {
      let list = []
      for (let date in listObj) {
        list.push({
          date,
          value: listObj[date],
          index: type === 'day' ? date : new Date(date).valueOf() // 用于排序
        })
      }

      switch (type) {
        case 'day':
          list.forEach(item => {
            item.date = item.date + ':00'
          })
          break
        case 'week':
          list.forEach(item => {
            item.date = Moment(item.date).format('MMMDo')
          })
          break
        case 'month':
          list.forEach(item => {
            item.date = Moment(item.date).format('MMMDo')
          })
          break
        case 'year':
          list.forEach(item => {
            item.date = Moment(item.date).format('MMM')
          })
      }

      list.sort((a, b) => a.index - b.index)
      return list
    },
    // 处理地图全屏
    handleMapFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        // 隐藏全部图表浮层
        this.chartPropNameList.forEach(item => {
          this[item].dispatchAction({ type: 'hideTip' })
        })
      } else {
        // 退出全屏，展示浮层
        this.resetLineChartDefaultTip()
      }
    },
    //选择趋势图类型
    setTrendActive(type){
      this.trendActive = type
      this.handleResize()
      /*if(type==2){
        this.stayInTrendChart && this.stayInTrendChart.resize()
      }else{
        this.checkInTrendChart && this.checkInTrendChart.resize()
      }*/
    }
  }
}
